import { useBemCN } from "@gik/core/utils/bemBlock";
import React from "react";
import type { Color } from "react-color";
import { HexInput } from "./HexInput";

export type SwatchHexPillProps = {
	color?: Color;
	onChange?: (hex: string) => void;
	/** Clicking the swatch selects this stop (used by the gradient picker). */
	onSwatchClick?: () => void;
	active?: boolean;
	className?: string;
};

// Shared "[swatch] # RRGGBB" pill used by the solid header and both gradient
// stops. The swatch is flush to the pill edge and doubles as a select target.
export function SwatchHexPill({
	color,
	onChange,
	onSwatchClick,
	active,
	className,
}: SwatchHexPillProps) {
	const bem = useBemCN("swatch-hex-pill");
	return (
		<div {...bem(null, [{ active }], className)}>
			<div
				{...bem("swatch")}
				style={{ backgroundColor: color?.toString() }}
				onClick={onSwatchClick}
			/>
			<HexInput value={color?.toString()} onChange={onChange} />
		</div>
	);
}
